/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DisclaimerInputs */

const id_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games Store buatan penggemar. Tidak terafiliasi dengan Epic Games, Inc. Semua logo, gambar, dan merek dagang milik pemiliknya masing-masing.`)
};

const ms_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalan data Epic Games Store buatan peminat. Tidak berafiliasi dengan Epic Games, Inc. Semua logo, imej, dan tanda dagangan adalah milik pemilik masing-masing.`)
};

const da_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En fan-lavet Epic Games Store database. Ikke tilknyttet Epic Games, Inc. Alle logoer, billeder og varemærker tilhører deres respektive ejere.`)
};

const de_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine von Fans erstellte Epic Games Store-Datenbank. Nicht verbunden mit Epic Games, Inc. Alle Logos, Bilder und Marken gehören ihren jeweiligen Besitzern.`)
};

const en_us2_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fan-made Epic Games Store database. Not affiliated with Epic Games, Inc. All logos, images, and trademarks belong to their respective owners.`)
};

const es_es2_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una base de datos de la Epic Games Store creada por fans. No está afiliada con Epic Games, Inc. Todos los logotipos, imágenes y marcas comerciales pertenecen a sus respectivos propietarios.`)
};

const es_mx2_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una base de datos de la Epic Games Store hecha por fans. No está afiliada con Epic Games, Inc. Todos los logotipos, imágenes y marcas comerciales pertenecen a sus respectivos dueños.`)
};

const fil_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang fan-made Epic Games Store database. Hindi kaakibat ng Epic Games, Inc. Lahat ng logo, larawan, at trademark ay pag-aari ng kani-kanilang may-ari.`)
};

const fr_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une base de données de l'Epic Games Store créée par des fans. Non affiliée à Epic Games, Inc. Tous les logos, images et marques commerciales appartiennent à leurs propriétaires respectifs.`)
};

const it_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un database dell'Epic Games Store creato da fan. Non affiliato con Epic Games, Inc. Tutti i loghi, le immagini e i marchi appartengono ai rispettivi proprietari.`)
};

const hu_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy rajongói készítésű Epic Games Store adatbázis. Nem áll kapcsolatban az Epic Games, Inc.-vel. Minden logó, kép és védjegy a jogosult tulajdonosoké.`)
};

const nl_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een fan-gemaakte Epic Games Store database. Niet gelieerd aan Epic Games, Inc. Alle logo's, afbeeldingen en handelsmerken zijn eigendom van hun respectieve eigenaren.`)
};

const no_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En fan-laget Epic Games Store-database. Ikke tilknyttet Epic Games, Inc. Alle logoer, bilder og varemerker tilhører sine respektive eiere.`)
};

const pl_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza danych Epic Games Store stworzona przez fanów. Niezwiązana z Epic Games, Inc. Wszystkie loga, obrazy i znaki towarowe należą do ich właścicieli.`)
};

const pt_br2_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma base de dados da Epic Games Store feita por fãs. Não afiliada à Epic Games, Inc. Todos os logotipos, imagens e marcas comerciais pertencem aos seus respectivos proprietários.`)
};

const pt_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma base de dados da Epic Games Store feita por fãs. Não afiliada à Epic Games, Inc. Todos os logótipos, imagens e marcas registadas pertencem aos seus respetivos proprietários.`)
};

const ro_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O bază de date a Epic Games Store creată de fani. Nu este afiliată cu Epic Games, Inc. Toate logo-urile, imaginile și mărcile comerciale aparțin proprietarilor lor respectivi.`)
};

const fi_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanien tekemä Epic Games Store -tietokanta. Ei sidoksissa Epic Games, Inc:iin. Kaikki logot, kuvat ja tavaramerkit kuuluvat omistajilleen.`)
};

const sv_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En fanbaserad Epic Games Store-databas. Inte ansluten till Epic Games, Inc. Alla logotyper, bilder och varumärken tillhör respektive ägare.`)
};

const vi_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở dữ liệu Epic Games Store do người hâm mộ tạo ra. Không liên kết với Epic Games, Inc. Mọi logo, hình ảnh và nhãn hiệu đều thuộc về chủ sở hữu tương ứng.`)
};

const tr_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayran yapımı bir Epic Games Store veritabanı. Epic Games, Inc. ile bağlantılı değildir. Tüm logolar, görseller ve ticari markalar ilgili sahiplerine aittir.`)
};

const cs_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanouškovská databáze Epic Games Store. Není přidružena k Epic Games, Inc. Všechna loga, obrázky a ochranné známky patří jejich příslušným vlastníkům.`)
};

const bg_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фенска база данни на Epic Games Store. Няма връзка с Epic Games, Inc. Всички лога, изображения и търговски марки принадлежат на съответните им собственици.`)
};

const ru_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фан-база данных Epic Games Store. Не связана с Epic Games, Inc. Все логотипы, изображения и товарные знаки принадлежат их законным владельцам.`)
};

const uk_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фан-база даних Epic Games Store. Не пов'язана з Epic Games, Inc. Усі логотипи, зображення та торговельні марки належать їхнім власникам.`)
};

const ar_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة بيانات Epic Games Store من صنع المعجبين. غير تابعة لشركة Epic Games, Inc. جميع الشعارات والصور والعلامات التجارية مملوكة لأصحابها.`)
};

const hi_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक फैन-निर्मित Epic Games Store डेटाबेस। Epic Games, Inc. से संबद्ध नहीं। सभी लोगो, छवियाँ और ट्रेडमार्क उनके संबंधित मालिकों के हैं।`)
};

const th_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานข้อมูล Epic Games Store ที่สร้างโดยแฟน ๆ ไม่เกี่ยวข้องกับ Epic Games, Inc. โลโก้ รูปภาพ และเครื่องหมายการค้าทั้งหมดเป็นของเจ้าของตามลำดับ`)
};

const ja_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファン制作の Epic Games Store データベースです。Epic Games, Inc. とは提携していません。すべてのロゴ、画像、商標はそれぞれの所有者に帰属します。`)
};

const zh_cn2_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一个粉丝制作的Epic游戏商城数据库，与Epic Games, Inc.无任何关联。所有Logo、图像和商标均属于其各自的所有者。`)
};

const zh_hant1_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是一個粉絲製作的Epic遊戲商城資料庫，與Epic Games, Inc.無任何關聯。所有Logo、圖像和商標均屬於其各自的所有者。`)
};

const ko_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팬 제작 Epic Games Store 데이터베이스입니다. Epic Games, Inc.와 제휴되어 있지 않습니다. 모든 로고, 이미지 및 상표는 해당 소유자의 자산입니다.`)
};

/**
* | output |
* | --- |
* | "A fan-made Epic Games Store database. Not affiliated with Epic Games, Inc. All logos, images, and trademarks belong to their respective owners." |
*
* @param {Footer_DisclaimerInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_disclaimer = /** @type {((inputs?: Footer_DisclaimerInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DisclaimerInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_disclaimer(inputs)
	if (locale === "ms") return ms_footer_disclaimer(inputs)
	if (locale === "da") return da_footer_disclaimer(inputs)
	if (locale === "de") return de_footer_disclaimer(inputs)
	if (locale === "en-US") return en_us2_footer_disclaimer(inputs)
	if (locale === "es-ES") return es_es2_footer_disclaimer(inputs)
	if (locale === "es-MX") return es_mx2_footer_disclaimer(inputs)
	if (locale === "fil") return fil_footer_disclaimer(inputs)
	if (locale === "fr") return fr_footer_disclaimer(inputs)
	if (locale === "it") return it_footer_disclaimer(inputs)
	if (locale === "hu") return hu_footer_disclaimer(inputs)
	if (locale === "nl") return nl_footer_disclaimer(inputs)
	if (locale === "no") return no_footer_disclaimer(inputs)
	if (locale === "pl") return pl_footer_disclaimer(inputs)
	if (locale === "pt-BR") return pt_br2_footer_disclaimer(inputs)
	if (locale === "pt") return pt_footer_disclaimer(inputs)
	if (locale === "ro") return ro_footer_disclaimer(inputs)
	if (locale === "fi") return fi_footer_disclaimer(inputs)
	if (locale === "sv") return sv_footer_disclaimer(inputs)
	if (locale === "vi") return vi_footer_disclaimer(inputs)
	if (locale === "tr") return tr_footer_disclaimer(inputs)
	if (locale === "cs") return cs_footer_disclaimer(inputs)
	if (locale === "bg") return bg_footer_disclaimer(inputs)
	if (locale === "ru") return ru_footer_disclaimer(inputs)
	if (locale === "uk") return uk_footer_disclaimer(inputs)
	if (locale === "ar") return ar_footer_disclaimer(inputs)
	if (locale === "hi") return hi_footer_disclaimer(inputs)
	if (locale === "th") return th_footer_disclaimer(inputs)
	if (locale === "ja") return ja_footer_disclaimer(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_disclaimer(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_disclaimer(inputs)
	return ko_footer_disclaimer(inputs)
});
export { footer_disclaimer as "footer.disclaimer" }